import { useSyncExternalStore } from "react";
import { readStoredString, writeStoredString } from "../../../shared/storage/storedString";

export type ToolCallDisplay = "hidden" | "condensed" | "detailed";
export const TOOL_CALL_DISPLAYS: readonly ToolCallDisplay[] = ["hidden", "condensed", "detailed"];
export const TOOL_CALL_DISPLAY_STORAGE_KEY = "dmw.toolCallDisplay";
export const DEFAULT_TOOL_CALL_DISPLAY: ToolCallDisplay = "condensed";

/** Local view preference; unknown values use the condensed default (web-app.md WA-4). */
export function parseToolCallDisplay(value: string | null): ToolCallDisplay {
  return value === "hidden" || value === "detailed" || value === "condensed" ? value : DEFAULT_TOOL_CALL_DISPLAY;
}

let profileDisplay: ToolCallDisplay | undefined;
const listeners = new Set<() => void>();
const notify = () => { for (const listener of listeners) listener(); };

export function getToolCallDisplay(): ToolCallDisplay {
  return profileDisplay ?? parseToolCallDisplay(readStoredString(TOOL_CALL_DISPLAY_STORAGE_KEY));
}

/** Set in Personal preferences only (F56): a Thread's header no longer changes it. */
export function setToolCallDisplay(display: ToolCallDisplay): void {
  profileDisplay = display;
  writeStoredString(TOOL_CALL_DISPLAY_STORAGE_KEY, display);
  notify();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  const onStorage = (event: StorageEvent) => {
    if (event.key === TOOL_CALL_DISPLAY_STORAGE_KEY || event.key === null) {
      profileDisplay = undefined;
      notify();
    }
  };
  window.addEventListener("storage", onStorage);
  return () => { listeners.delete(listener); window.removeEventListener("storage", onStorage); };
}

/** All Thread views update together. */
export function useToolCallDisplay(): ToolCallDisplay {
  return useSyncExternalStore(subscribe, getToolCallDisplay, () => DEFAULT_TOOL_CALL_DISPLAY);
}
